import { useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Grid,
  Typography,
} from "@mui/material";

export default function UserProfileForm() {
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    postcode: "",
    doi: "",
    certificate_no: "",
    countersignatory_details: "",
    registered_entity: "",
    countersignatory: "",
    dbs_children_barred_list: "",
    dbs_adults_barred_list: "",
    other_info_by_police: "",
    enhanced_certification: "",
    address: "",
    police_records: "",
    section_information: "",
    employer: "",
    position: "",
    employment_details: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        User Profile Form
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Name" name="name" value={formData.name} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField type="date" fullWidth label="Date of Birth" name="dob" InputLabelProps={{ shrink: true }} value={formData.dob} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField select fullWidth label="Gender" name="gender" value={formData.gender} onChange={handleChange}>
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Postcode" name="postcode" value={formData.postcode} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField type="date" fullWidth label="DOI" name="doi" InputLabelProps={{ shrink: true }} value={formData.doi} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Certificate No" name="certificate_no" value={formData.certificate_no} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Countersignatory Details" name="countersignatory_details" value={formData.countersignatory_details} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Registered Entity" name="registered_entity" value={formData.registered_entity} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Countersignatory" name="countersignatory" value={formData.countersignatory} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="DBS Children Barred List" name="dbs_children_barred_list" value={formData.dbs_children_barred_list} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="DBS Adults Barred List" name="dbs_adults_barred_list" value={formData.dbs_adults_barred_list} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Other Info by Police" name="other_info_by_police" value={formData.other_info_by_police} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Enhanced Certification" name="enhanced_certification" value={formData.enhanced_certification} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Address" name="address" value={formData.address} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Police Records" name="police_records" value={formData.police_records} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Section Information" name="section_information" value={formData.section_information} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Employer" name="employer" value={formData.employer} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Position" name="position" value={formData.position} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Employment Details" name="employment_details" value={formData.employment_details} onChange={handleChange} />
        </Grid>
      </Grid>

      <Button
        variant="contained"
        type="submit"
        sx={{ mt: 3, background: "linear-gradient(90deg, #a1c97b, #8bbd5d)" }}
      >
        Submit
      </Button>
    </Box>
  );
}
